<template>
  <v-dialog v-model="dialog" persistent max-width="1000">

    <v-card>
      <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
        Candidate logs
      </v-card-title>

      <v-card-text>
        <v-row v-if="r">
          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} py-0`" v-for="(log, ll) in r.log" :key="'log'+ll">
            <v-row class="py-0 align-center">
              <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
                {{log.user ? log.user : 'SYSTEM'}}
              </v-col>
              <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip x-small v-bind="attrs" v-on="on">{{log.description}}</v-chip>
                  </template>
                  <div class="text-center">
                    <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} py-0`">{{log.properties}}</div>
                  </div>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
                <v-chip x-small v-if="log.status">{{log.status}}</v-chip>
              </v-col>
              <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} py-0`">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" v-if="log.created_at">
                      <v-icon size="10">date_range</v-icon>
                      {{log.created_at.split('T')[0]}} |
                      <v-icon size="10">schedule</v-icon>
                      {{log.created_at.split('T')[1].split('.')[0]}}</span>
                  </template>
                  <div class="text-center">
                    <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} py-0`">{{log.created_at}}</div>
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn @click.prevent="$emit('close')" color="error" text>{{  i18n.close }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  props: ['r', 'dialog'],
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
}
</script>